import {
  getHeroContent,
  getSolutions,
  getProjects,
  getClients,
  getBottomSection,
  getExtraSectionContent,
  getFooterContent,
} from "./HomePageContent";
import { findObjectUseCase } from "../../usecases/object";

class HomePresenter {
  constructor(view) {
    this.view = view;
    this.projectSlideInterval = null;
    this.solutionsSlideInterval = null;
  }

  initialize() {
    this.fetchHeroContent();
    this.getThreeCardSectionContent();
    this.getClientsSectionContent();

    // Fade-in Hero
    this.view.heroTimeout = setTimeout(
      () => this.view.setState({ showHero: true }),
      1300
    );

    // Auto-slide projects
    this.projectSlideInterval = setInterval(this.view.nextProjectSlide, 4000);

    // Listen to scroll
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  cleanup() {
    clearTimeout(this.view.heroTimeout);
    clearInterval(this.projectSlideInterval);
    clearInterval(this.solutionsSlideInterval);
    window.removeEventListener("scroll", this.handleScroll.bind(this));
  }

  fetchHeroContent() {
    try {
      const heroContent = getHeroContent();
      this.view.setState({ heroContent, loadingHero: false });
    } catch (error) {
      this.view.showError(error);
    }
  }

  handleScroll() {
    const triggerPoint = window.innerHeight * 0.6;

    // Solutions Section
    const solTop = this.view.solutionRef.current?.getBoundingClientRect().top;
    if (solTop < triggerPoint && !this.view.state.showCards) {
      this.view.setState({ showCards: true }, () => {
        this.solutionsSlideInterval = setInterval(this.view.nextSlide, 3000);
      });
    }

    // Extra Section
    const extraTop =
      this.view.extraSectionRef.current?.getBoundingClientRect().top;
    if (extraTop < triggerPoint && !this.view.state.showExtraSection) {
      this.view.setState({ showExtraSection: true });
    }

    // Projects Section
    const projTop = this.view.projectsRef.current?.getBoundingClientRect().top;
    if (projTop < triggerPoint && !this.view.state.showProjects) {
      this.view.setState({ showProjects: true });
    }

    // Clients Section
    const clientsTop =
      this.view.clientsRef.current?.getBoundingClientRect().top;
    if (clientsTop < triggerPoint && !this.view.state.showClients) {
      this.view.setState({ showClients: true });
    }

    // Bottom image fade-slide in
    // Bottom Section
    const bottomTop = this.view.bottomRef.current?.getBoundingClientRect().top;
    if (bottomTop < triggerPoint && !this.view.state.showImage) {
      this.view.setState({ showImage: true });
    }
  }

  nextProjectSlide() {
    const cards = this.view.state?.projects;
    console.log(cards, "cards");
    const maxIndex = cards.length - 3;
    this.view.setState((prev) => ({
      projectSlideIndex:
        prev.projectSlideIndex >= maxIndex ? 0 : prev.projectSlideIndex + 1,
      slideDirection: "left",
      isSliding: true,
    }));
    setTimeout(() => this.view.setState({ isSliding: false }), 600);
  }

  prevProjectSlide() {
    const cards = this.view.state.projects;
    const maxIndex = cards.length - 3;
    this.view.setState((prev) => ({
      projectSlideIndex:
        prev.projectSlideIndex <= 0 ? maxIndex : prev.projectSlideIndex - 1,
      slideDirection: "right",
      isSliding: true,
    }));
    setTimeout(() => this.view.setState({ isSliding: false }), 600);
  }

  getSolutionsSectionContent() {
    const solutions = getSolutions();
    return {
      title: "Our Solutions",
      cardStyle: {
        backgroundColor: "#E6EDE6",
        padding: "20px",
        minHeight: "300px",
      },
      rowStyle: { padding: "1rem" },
      imageStyle: {
        maxHeight: "110%",
        maxWidth: "110%",
        objectFit: "contain",
      },
      solutions,
    };
  }

  async getThreeCardSectionContent() {
    // return getProjects();
    const response = await findObjectUseCase().execute("projects");
    this.view.setState({ projects: response });
  }

  async getClientsSectionContent() {
    // return getClients();
    const response = await findObjectUseCase().execute("clients");
    this.view.setState({ clients: response });
  }

  getBottomSectionContent() {
    return getBottomSection();
  }

  getExtraSectionContent() {
    return getExtraSectionContent();
  }

  getFooterContent() {
    return getFooterContent();
  }
}

export default HomePresenter;
